import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  dragOver(event) {
    event.preventDefault();
    this.element.classList.add("dragging");
  }

  dragLeave(event) {
    event.preventDefault();
    this.element.classList.remove("dragging");
  }

  drop(event) {
    console.log("Drop event triggered");
    event.preventDefault();
    this.element.classList.remove("dragging");

    const productId = window.draggedProductId;
    console.log("Product ID:", productId);
    
    if (productId) {
      // Find the link using the dynamic ID
      const link = document.getElementById(`product_${productId}`);
      console.log("Found link:", link);
      
      if (link) {
        link.click();
      }
    }
  }
} 